// React Router
import { useNavigate } from 'react-router-dom';

// Assets
import logo from '../../assets/logo.jpg';

// MUI
import { Box, useTheme, Card, CardContent, Typography, CardActionArea, Avatar } from '@mui/material'

export default function Logout() {
    const navigate = useNavigate();

    const myTheme = useTheme();
    return (
        <Box sx={{
            display: "flex", justifyContent: "center", alignItems: "center", flex: "1", height: "100vh",
            backgroundColor: `${myTheme.palette.background.default}`, padding: "0 20px"
        }}
        >
            <Card sx={{ maxWidth: 345, borderRadius: "15px" }}
                onClick={() => {
                    navigate("/home");
                }}>
                <CardActionArea sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "0 10px", }}>
                    <Avatar alt="logo" src={logo} sx={{ width: "60px", height: "60px", borderRadius: "50%", }} />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            {localStorage.getItem("username") || "Ali Hassan"}
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            Sign In
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        </Box>
    )
}
